const AllObjectsTypes = {
    SET_ALL_OBJECTS: "themet/setAllObjects", // to set all objects from the met api
    CLEAN_ALL_OBJECTS: "themet/cleanAllObjects", // to free the object list
}

export default AllObjectsTypes;